import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-wallet-icon',
  templateUrl: './wallet.svg',
  styleUrls: ['./wallet-icon.component.scss'],
})
export class WalletIconComponent {
  @Input() fillColor = '#808080';
  @Input() strokeColor = '#808080';
}
